<template>
    <div :id="id"></div>
</template>

<script>
import EventBus from '../../modules/EventBus';

export default {
    name: 'BnScrollToAnchor',

    props: ['id', 'finished'],

    watch: {
        finished(val) {
            EventBus.$emit('set-anchor-finished-status', { status: val, id: this.id });
        },
    },

    mounted() {
        window.addEventListener('scroll', this.handleScrollEvent);
    },

    destroyed() {
        window.removeEventListener('scroll', this.handleScrollEvent);
    },

    methods: {
        handleScrollEvent() {
            const rect = document.getElementById(this.id).getBoundingClientRect();
            const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

            if (!((rect.bottom + viewHeight * (7 / 8)) < 0 || (rect.top + viewHeight * (7 / 8)) - viewHeight >= 0)) {
                EventBus.$emit('anchor-entered-screen', { id: this.id, top: rect.top + viewHeight / 2 });
            }
        },
    },

};
</script>

<style scoped>
    .anchor-wrapper {
        height: 100px;
    }
</style>
